<pw-view-title>{{(supplier$ | async)?.TEXT}}</pw-view-title>

<mat-expansion-panel expanded *ngIf="supplier$ | async as supplier">
  <mat-expansion-panel-header>{{'contacts.details.detailsPanel.details' | translate}}</mat-expansion-panel-header>

  <div style="display: grid; grid-template-columns: auto 1fr; gap: 12px">
    <div>{{'contacts.details.detailsPanel.name' | translate}}</div>
    <div>{{supplier.NAME}}</div>
    <div>{{'contacts.details.detailsPanel.description' | translate}}</div>
    <div>{{supplier.DESCRIPTION}}</div>
    <div>{{'contacts.details.detailsPanel.type' | translate}}</div>
    <div>{{supplier.TYPNAME}}</div>
    <div>{{'contacts.details.detailsPanel.responsible' | translate}}</div>
    <div>{{supplier.RESPNAME}}</div>
  </div>
</mat-expansion-panel>

<mat-tab-group>

  <mat-tab label="{{'contacts.details.contactsTab.contacts' | translate}}">
    <div class="contacts-grid">
      <div class="mat-elevation-z6">
        <div class="ps-flex-container-row">
          <h3>{{'contacts.details.contactsTab.contacts' | translate}}</h3>
          <div style="flex: 1 0 auto"></div>
          <button mat-mini-fab color="accent" matTooltip="{{'contacts.details.contactsTab.createContact' | translate}}"
                  (click)="createContact()">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <mat-selection-list multiple="false">
          <mat-list-option *ngFor="let contact of contacts$ | async" (click)="selectContact(contact)">
            <span matListItemTitle>{{contact.DESCRIPTION}}</span>
            <span matListItemLine>{{contact.NAME}}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>

      <div *ngIf="selectedContact$ | async as contact" class="mat-elevation-z6">
        <div class="ps-flex-container-col">
          <h3>Kontaktinformationen</h3>
          <mat-form-field>
            <mat-label>{{'contacts.details.contactsTab.firstName' | translate}}</mat-label>
            <input matInput [(ngModel)]="contact.NAME" (change)="contactChanged()">
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{'contacts.details.contactsTab.lastName' | translate}}</mat-label>
            <input matInput [(ngModel)]="contact.DESCRIPTION" (change)="contactChanged()">
          </mat-form-field>
          <div></div>
          <div class="ps-flex-container-row" style="justify-content: end">
            <button mat-button color="accent" matTooltip="Kontakt löschen" (click)="deleteContact(contact)">
              {{'contacts.details.contactsTab.delete' | translate}}
            </button>
            <button mat-button color="accent" *ngIf="contactEdited$ | async" matTooltip="Änderungen übernehmen"
                    (click)="updateContact(contact)">
              {{'contacts.details.contactsTab.save' | translate}}
            </button>
          </div>
        </div>
      </div>

      <ng-container *ngIf="selectedContact$ | async as contact">
        <div class="connections-grid mat-elevation-z6">
          <div class="ps-flex-container-col">
            <div class="ps-flex-container-row" style="padding: 0px">
              <h3>{{'contacts.details.contactsTab.connections' | translate}}</h3>
              <div style="flex: 1 0 auto"></div>
              <button mat-mini-fab matTooltip="{{'contacts.details.contactsTab.addConnection' | translate}}"
                      color="accent"
                      (click)="createConnection(contact)">
                <mat-icon>add</mat-icon>
              </button>
            </div>

            <mat-selection-list multiple="false" *ngIf="contactConnections$ | async as connections">
              <mat-list-option *ngFor="let con of connections" (click)="selectContactConnection(con)">
                <span matListItemTitle>{{con.CONNECT_TYP_NAME}}</span>
              </mat-list-option>
            </mat-selection-list>
          </div>
          <mat-divider vertical></mat-divider>
          <div *ngIf="selectedContactConnection$ | async as contactConnection" class="ps-flex-container-col">
            <h3>{{'contacts.details.contactsTab.connectionInfo' | translate}}</h3>
            <div class="ps-flex-container-col">
              <mat-form-field>
                <mat-label>{{'contacts.details.contactsTab.data' | translate}}</mat-label>
                <input matInput [(ngModel)]="contactConnection.TEXT"/>
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{'contacts.details.contactsTab.info' | translate}}</mat-label>
                <input matInput [(ngModel)]="contactConnection.INFO"/>
              </mat-form-field>
              <div style="display: flex;justify-content: end">
                <button mat-button color="accent"
                        matTooltip="{{'contacts.details.contactsTab.deleteConnection' | translate}}"
                        (click)="deleteConnection(contact, contactConnection)">
                  {{'contacts.details.contactsTab.delete' | translate}}
                </button>
                <button mat-button color="accent"
                        matTooltip="{{'contacts.details.contactsTab.acceptChanges' | translate}}"
                        (click)="updateConnection(contact, contactConnection)">
                  {{'contacts.details.contactsTab.save' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-tab>

  <mat-tab label="{{'contacts.details.addressTab.addresses' | translate}}">
    <div class="two-containers-grid">
      <div class="mat-elevation-z6">
        <div class="ps-flex-container-row">
          <h3>{{'contacts.details.addressTab.addresses' | translate}}</h3>
          <div style="flex: 1 0 auto"></div>
          <button mat-mini-fab color="accent" matTooltip="{{'contacts.details.addressTab.addAddress' | translate}}"
                  (click)="createAddress()">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <mat-selection-list multiple="false">
          <mat-list-option *ngFor="let address of addresses$ | async" (click)="selectAddress(address)">
            <span matListItemLine>{{address.ADDRESSTYPENAME}}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>

      <div class="ps-flex-container-col mat-elevation-z6" style="padding: 12px"
           *ngIf="selectedAddress$ | async as address; else noAddressSelected">
        <h3>Details</h3>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.type' | translate}}</mat-label>
          <mat-select [(ngModel)]="address.OBJECT_ID" multiple="false" [compareWith]="compareObjects">
            <mat-option *ngFor="let type of addressTypes$ | async" [value]="type.OBJECT_ID">
              <img [src]="type.ICON_URL"/>
              {{type.NAME}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.postal' | translate}}</mat-label>
          <input matInput [(ngModel)]="address.PLZSTR">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.street' | translate}}</mat-label>
          <input matInput [(ngModel)]="address.STRASSE">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.city' | translate}}</mat-label>
          <input matInput [(ngModel)]="address.STADT">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.country' | translate}}</mat-label>
          <mat-select [(ngModel)]="address.LAND_ID" multiple="false">
            <mat-option *ngFor="let country of countries$ | async" [value]="country.OBJECT_ID">
              <img [src]="country.ICON_URL"/>
              {{country.NAME}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.poBox' | translate}}</mat-label>
          <input matInput [(ngModel)]="address.POSTFACH">
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.addressTab.description' | translate}}</mat-label>
          <input matInput [(ngModel)]="address.DESCRIPTION">
        </mat-form-field>
        <div style="justify-content: end; display: flex">
          <button mat-button color="accent" matTooltip="Anschrift löschen" (click)="deleteAddress(address)">
            {{'contacts.details.addressTab.delete' | translate}}
          </button>
          <button mat-button color="accent" matTooltip="Änderungen übernehmen" (click)="updateAddress(address)">
            {{'contacts.details.addressTab.acceptChanges' | translate}}
          </button>
        </div>
      </div>
      <ng-template #noAddressSelected>
        <div class="ps-flex-container-col mat-elevation-z6">
          <h3>{{'contacts.details.addressTab.noAddressSelected' | translate}}</h3>
        </div>
      </ng-template>
    </div>
  </mat-tab>

  <mat-tab label="{{'contacts.details.connectionsTab.connections' | translate}}" *ngIf="supplier$ | async as supplier">
    <div class="two-containers-grid">
      <div class="mat-elevation-z6">
        <div class="ps-flex-container-row">
          <h3>{{'contacts.details.connectionsTab.connections' | translate}}</h3>
          <div style="flex: 1 0 auto"></div>
          <button mat-mini-fab color="accent"
                  matTooltip="{{'contacts.details.connectionsTab.addConnection' | translate}}"
                  (click)="createConnection(supplier)">
            <mat-icon>add</mat-icon>
          </button>
        </div>

        <mat-selection-list multiple="false">
          <mat-list-option *ngFor="let connection of connections$ | async"
                           (click)="selectConnection(connection)">
            <span matListItemLine>{{connection.CONNECTIONTYPENAME}}</span>
          </mat-list-option>
        </mat-selection-list>
      </div>

      <div class="ps-flex-container-col mat-elevation-z6" style="padding: 12px"
           *ngIf="selectedConnection$ | async as selectedConnection; else noConnectionSelected">
        <h3>Details</h3>
        <mat-form-field>
          <mat-label>{{'contacts.details.connectionsTab.type' | translate}}</mat-label>
          <mat-select [(ngModel)]="selectedConnection.CONNECT_TYP_ID" multiple="false">
            <mat-option *ngFor="let conType of connectionTypes$ | async"
                        [value]="conType.OBJECT_ID">
              <mat-icon matSuffix><img [src]="conType.ICON_URL"/></mat-icon>
              {{conType.NAME}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.connectionsTab.data' | translate}}</mat-label>
          <input matInput [(ngModel)]="selectedConnection.TEXT"/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{'contacts.details.connectionsTab.info' | translate}}</mat-label>
          <input matInput [(ngModel)]="selectedConnection.INFO"/>
        </mat-form-field>
        <div style="justify-content: end; display: flex">
          <button mat-button color="accent"
                  matTooltip="{{'contacts.details.connectionsTab.deleteConnection' | translate}}"
                  (click)="deleteConnection(supplier, selectedConnection)">
            {{'contacts.details.connectionsTab.delete' | translate}}
          </button>
          <button mat-button color="accent"
                  matTooltip="{{'contacts.details.connectionsTab.saveConnection' | translate}}"
                  (click)="updateConnection(supplier, selectedConnection)">
            {{'contacts.details.connectionsTab.save' | translate}}
          </button>
        </div>
      </div>
      <ng-template #noConnectionSelected>
        <div class="ps-flex-container-col mat-elevation-z6">
          <h3>{{'contacts.details.connectionsTab.noConnectionSelected' | translate}}</h3>
        </div>
      </ng-template>
    </div>
  </mat-tab>
</mat-tab-group>
